<!-- Standard Confirmation Dialog -->
<div class="dialog-overlay" *ngIf="activeDialog && activeDialog.confirmText != 'Assign'" (click)="onCancel()">
    <div class="dialog-card" (click)="$event.stopPropagation()">
        <!-- Header -->
        <div class="modal-header">
            <div class="header-content">
                <div class="dialog-icon" [ngClass]="activeDialog.type || 'warning'">
                    <ng-container [ngSwitch]="activeDialog.type">
                        <svg *ngSwitchCase="'info'" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3" />
                        </svg>
                        <svg *ngSwitchDefault xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" />
                        </svg>
                    </ng-container>
                </div>
                <h3 class="modal-title">{{activeDialog.title}}</h3>
            </div>
            <button class="close-btn" (click)="onCancel()">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
            </button>
        </div>

        <!-- Body -->
        <div class="modal-body">
            <p class="dialog-message" [innerHTML]="activeDialog.message"></p>
        </div>

        <!-- Footer -->
        <div class="modal-footer">
            <button class="btn btn-secondary" (click)="onCancel()">{{activeDialog.cancelText}}</button>
            <button class="btn btn-primary" (click)="onConfirm()">
                <ng-container [ngSwitch]="activeDialog.confirmText">
                    <svg *ngSwitchCase="'Unassign'" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                        stroke-width="1.5" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M22 10.5h-6m-2.25-4.125a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0ZM4 19.235v-.11a6.375 6.375 0 0 1 12.75 0v.109A12.318 12.318 0 0 1 10.374 21c-2.331 0-4.512-.645-6.374-1.766Z" />
                    </svg>
                    <svg *ngSwitchCase="'Import'" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                        stroke-width="1.5" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3" />
                    </svg>
                    <svg *ngSwitchDefault xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                        stroke-width="1.5" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                    </svg>
                </ng-container>
                {{activeDialog.confirmText}}
            </button>
        </div>
    </div>
</div>

<!-- Assign Special Dialog -->
<div class="dialog-overlay" *ngIf="activeDialog && activeDialog.confirmText === 'Assign'" (click)="onCancel()">
    <div class="dialog-card" (click)="$event.stopPropagation()">
        <!-- Header -->
        <div class="modal-header">
            <div class="header-content">
                <div class="dialog-icon" [ngClass]="activeDialog.type || 'warning'">
                    <ng-container [ngSwitch]="activeDialog.type">
                        <svg *ngSwitchCase="'info'" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3" />
                        </svg>
                        <svg *ngSwitchDefault xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" />
                        </svg>
                    </ng-container>
                </div>
                <h3 class="modal-title">{{activeDialog.title}}</h3>
            </div>
            <button class="close-btn" (click)="onCancel()">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
            </button>
        </div>

        <!-- Body -->
        <div class="modal-body">
            <p class="dialog-message" [innerHTML]="activeDialog.message"></p>
            <div class="form-group">
                <label class="form-label">Select Driver</label>
                <div class="select-wrapper">
                    <select [(ngModel)]="selectedDriverId" class="select-input">
                        <option value="" disabled>Select Driver</option>
                        <option *ngFor="let driver of driverList" [value]="driver.value">
                            {{ driver.label }}
                        </option>
                    </select>
                    <svg class="select-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                        stroke-width="2" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                    </svg>
                </div>
            </div>
        </div>

        <!-- Footer -->
        <div class="modal-footer">
            <button class="btn btn-secondary" (click)="onCancel()">{{activeDialog.cancelText}}</button>
            <button class="btn btn-primary" (click)="AssignConfirm()">
                <ng-container [ngSwitch]="activeDialog.confirmText">
                    <svg *ngSwitchCase="'Unassign'" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                        stroke-width="1.5" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M22 10.5h-6m-2.25-4.125a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0ZM4 19.235v-.11a6.375 6.375 0 0 1 12.75 0v.109A12.318 12.318 0 0 1 10.374 21c-2.331 0-4.512-.645-6.374-1.766Z" />
                    </svg>
                    <svg *ngSwitchCase="'Import'" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                        stroke-width="1.5" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3" />
                    </svg>
                    <svg *ngSwitchDefault xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                        stroke-width="1.5" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                    </svg>
                </ng-container>
                {{activeDialog.confirmText}}
            </button>
        </div>
    </div>
</div>